import { DatePipe, KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  Signal,
  computed,
  inject
} from '@angular/core';
import { SelectComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { TwcLayerType } from '../../../twc.mixin';

@Component({
  selector: 'jmkw-flight-level-select',
  templateUrl: './flight-level-select.component.html',
  styleUrls: ['./flight-level-select.component.scss'],
  standalone: true,
  imports: [SelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightLevelSelectComponent {
  datePipe = inject(DatePipe);
  @Input() layer?: TwcLayerType;
  @Output() selectionChanged = new EventEmitter<string>();

  flightLevels: Signal<Record<string, string>> = computed(() =>
    (this.layer?.flightLevelValues?.() ?? []).reduce(
      (acc, flightLevelValue) => {
        const key = `${flightLevelValue}`;
        return {
          ...acc,
          [key]: flightLevelValue
        };
      },
      {} as Record<string, string>
    )
  );

  get initialValue() {
    return this.layer?.selectedFlightLevel;
  }

  onSelectionChangeHandler(keyValue: KeyValue<string, string> | null) {
    if (keyValue) {
      this.selectionChanged.emit(keyValue.value);
    }
  }
}
